
import { Company } from "@/models/company";
import { CompanyModule } from "@/models/company-module";
import { Module } from "@/models/module";
import { CompanyService } from "@/services/company-service";
import {ModuleService} from "@/services/module-service";
import AppCompanyEditModuleMetaData from "./CompanyEditModuleMetaData.vue";
import Vue from "vue";
import AppCompanyEditWrapper from "@/components/company/CompanyEditWrapper.vue";
import { HttpError } from "@/utils/http-error";
import { SubscriptionSerivce } from "@/services/subscription-service";
import { Subscription } from "@/models/subscription";
import { toDateString } from "@/utils/strings";
import { MODULE } from "@/config/modules";


export default Vue.extend({
	data() {
		return {
			addOpened: false,
			toEditModule: null as null | CompanyModule,
			columns: [
				{
					name: "Id",
					property: "id",
					width: "50px"
				},
				{
					name: "Name",
					property: "name",
					width: "400px"
				}
			],
			selectedAddRows: [] as Module[],
			selectedRows: [] as CompanyModule[],
			orderColumn: "id",
			orderDirection: false,
			searchInput: "",
			addSearchInput: "",
			currentSubscription: null as null | Subscription,
		};
	},
	props: {
		value: {
			type: Object as () => Company,
			required: true
		},
	},
	computed: {
		allModules():Module[] {
			let result = ModuleService.modules.filter(m => {
				return this.value.modules.findIndex(mod => mod.id == m.id) == -1;
			});
			if (this.addSearchInput){
				result = result.filter(i=>{
					if (i.name.toLowerCase().indexOf(this.addSearchInput.toLowerCase()) != -1){
						return true;
					}
					if (`${i.id}`.indexOf(this.addSearchInput) != -1){
						return true;
					}
					return false;
				});
			}
			return result;
		},
		noModulesSelected():boolean {
			return this.selectedRows.length == 0;
		},
		editDisabled():boolean {
			if (this.selectedRows.length != 1){
				return true;
			}
			return this.selectedRows[0].getEditMetaDataComponent() == null;
		},
		sortedModules():CompanyModule[] {
			let items = [...this.value.modules];
			if (this.searchInput){
				items = items.filter(i=>{
					if (i.name.toLowerCase().indexOf(this.searchInput.toLowerCase()) != -1){
						return true;
					}
					if (`${i.id}`.indexOf(this.searchInput) != -1){
						return true;
					}
					return false;
				});
			}
			items.sort((a,b):number=>{
				if (this.orderColumn == "id") {
					if (this.orderDirection) {
						return a.id - b.id;
					}
					return b.id - a.id;
				}
				if (this.orderDirection) {
					return a.name.localeCompare(b.name);
				}
				return b.name.localeCompare(a.name);
			});
			return items;
		},
	},
	methods: {
		addIconClicked() {
			this.addOpened = true;
		},
		async addModules() {
			let modules = [...this.selectedAddRows];
			let comp = await CompanyService.addModulesToCompany(this.value, modules.map(m=>m.toCompanyModule()));
			this.$emit("input", comp);
			for (let mod of modules) {
				if (mod.id == MODULE.ELECTRONISCHE_FACTURATIE) {
					await this.editModule(mod, comp);
				}
			}
			this.addOpened = false;
			this.addSearchInput = "";
			this.addModulesToSubscription(modules);
		},
		async addModulesToSubscription(modules:Module[]){
			if (!this.currentSubscription) return;
			for (let m of modules) {
				this.currentSubscription.plan.addModule(m);
			}
			this.currentSubscription = await SubscriptionSerivce.editMetadata(this.value.id, this.currentSubscription.id, this.currentSubscription.plan.getJson());
			this.askToUpdatePriceOfSubscription();
		},
		async removeIconClicked() {
			let modules = [...this.selectedRows];
			let comp = await CompanyService.removeModulesFromCompany(this.value, modules);
			this.$emit("input", comp);
			this.selectedRows = [];
			this.removeModulesFromSubscription(modules);
		},
		async removeModulesFromSubscription(modules:CompanyModule[]){
			if (!this.currentSubscription) return;
			for (let m of modules) {
				this.currentSubscription.plan.removeModule(m.id);
			}
			this.currentSubscription = await SubscriptionSerivce.editMetadata(this.value.id,this.currentSubscription.id, this.currentSubscription.plan.getJson());
			this.askToUpdatePriceOfSubscription();
		},
		async onMetaDataSaved(m:CompanyModule){
			if (!this.currentSubscription) return;
			this.currentSubscription.plan.addModule(m.id, m.metaData);
			this.currentSubscription = await SubscriptionSerivce.editMetadata(this.value.id, this.currentSubscription.id, this.currentSubscription.plan.getJson());
			this.askToUpdatePriceOfSubscription();
		},
		async askToUpdatePriceOfSubscription(){
			if (!this.currentSubscription) return;
			let currentPrice = this.currentSubscription.price;
			let newPrice = await SubscriptionSerivce.computePriceOfPlan(this.value.id, this.currentSubscription.plan);
			if (currentPrice == newPrice) return;

			let nextPaymentDate = toDateString(this.currentSubscription.nextPaymentDate);
			let text = `Wilt u de prijs van het abonnement ook aanpassen van €${currentPrice} naar de voorgesteld prijs €${newPrice}. `;
			text += `De volgende betaling gaat dan deze prijs hebben op ${nextPaymentDate}`;
			let confirm = await this.$wf.confirm(text, "Ja", "Nee", "Waarschuwing", "warning");
			if (!this.currentSubscription) return;
			if (!confirm) return;
			this.currentSubscription = await SubscriptionSerivce.editSubscriptionPrice(this.value.id, this.currentSubscription.id, newPrice,this.currentSubscription.plan);
		},
		async editModule(mod:Module, company?:Company){
			let comp = this.value;
			if (company){
				comp = company;
			}
			let compMod = comp.modules.find(c=>c.id == mod.id);
			await this.edit(compMod);
		},
		async edit(m?:CompanyModule){
			if (!m){
				m = this.selectedRows[0];
			}
			if (m.getEditMetaDataComponent() == null){
				return;
			}
			this.toEditModule = m;
			await new Promise((resolve)=>{
				this.$once("edit-module-closed", resolve);
			});
		},
		closeEditModule(){
			this.toEditModule = null;
			this.$emit("edit-module-closed");
		},
		onOrder(event:any) {
			this.orderColumn = event.order;
			this.orderDirection = event.ascending;
		},
		async fetchCurrentSubscription(){
			if (!this.value.MollieCustomerID) {
				this.currentSubscription = null;
				return;
			};
			try{
				this.currentSubscription = await SubscriptionSerivce.getCurrentSubscription(this.value.id);
			}catch(err){
				let e = err as HttpError;
				e.dontShow = true;
			}
		}
	},
	async created(){
		await this.fetchCurrentSubscription();
	},
	components: {
		AppCompanyEditModuleMetaData,
		AppCompanyEditWrapper
	}
});
